"use strict";

function GuideWireService($http, storage, util) {

    var mulesoftApiHeaders = (endpointUrls.rego.mulesoftApiHeader) 
    ? { 
        'X-SourceSystem': 'Sitecore',
        'X-TrackingID': '',
        'X-Mockable': (endpointUrls.rego.mulesoftApiHeader.xMockable) ? true : false,
    }
    : {};

    var conf = {
        embargo: {
            method: 'GET',
            url: '',
            headers: {
                'X-Mockable': endpointUrls.quote.embargoxMockable,
                'X-SourceSystem': '',
                'X-TrackingID': '',
                'X-TargetEnv': '',
            },
        },
        regoSearch: {
            method: 'GET',
            url: endpointUrls.rego.regoSearch,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'X-Requested-By': '98wuebh3e2',
                'UserID': ""
            },
        },
        makeSearch: {
            method: 'GET',
            url: endpointUrls.rego.makeSearch,
            headers: getMulesoftApiHeadersForVgi(mulesoftApiHeaders),
        },
        modelSearch: {
            method: 'GET',
            url: endpointUrls.rego.modelSearch,
            headers: getMulesoftApiHeadersForVgi(mulesoftApiHeaders),
        },
        carSearch: {
            method: 'GET',
            url: endpointUrls.rego.carSearch,
            headers: getMulesoftApiHeadersForVgi(mulesoftApiHeaders),
        },
        addressSearch: {
            method: 'GET',
            url: endpointUrls.addresses.addressSearch,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc'
            },
        },
        createQuote: {
            method: 'POST',
            url: endpointUrls.quote.quote,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'channel': 'portal',
                Accept: "application/json, text/plain, */*",
                'Cache-Control': "no-cache",
                Pragma: "no-cache",
                'X-Requested-By': "92tvt8iy2b"
            },
        },
        updateQuote: {
            method: 'PUT',
            url: endpointUrls.quote.quote,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'channel': 'portal',
                Accept: "application/json, text/plain, */*",
                'Cache-Control': "no-cache",
                Pragma: "no-cache",
                'X-Requested-By': "92tvt8iy2b"
            },
        },
        quickQuote: {
            method: 'POST',
            url: endpointUrls.quote.quickQuote,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'channel': 'portal',
                Accept: "application/json, text/plain, */*",
                'Cache-Control': "no-cache",
                Pragma: "no-cache",
                'X-Requested-By': "92tvt8iy2b"
            },
        },
		triggerGoal: {
			method: 'POST',
			url: '/sitecore/api/qbe/Experience/TriggerGoal',
			headers: {
				'EY-Access-Key': 'test123',
				'EY-Product-Type': 'pc',
				'channel': 'portal',
				Accept: "application/json, text/plain, */*",
				'Cache-Control': "no-cache",
				Pragma: "no-cache",
				'X-Requested-By': "92tvt8iy2b"
			},
		},		
        retrieveSavedQuote: {
            method: 'GET',
            url: endpointUrls.quote.retrieveSavedQuote,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'channel': 'portal',
                Accept: "application/json, text/plain, */*",
                'Cache-Control': "no-cache",
                Pragma: "no-cache",
                'X-Requested-By': "92tvt8iy2b"
            },
        },
        isCampaignCodeValid: {
            method: 'HEAD',
            url: endpointUrls.quote.campaign,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'X-Requested-By': '92tvt8iy2b'
            },
        },
        refreshAddress: {
            method: 'POST',
            url: endpointUrls.addresses.refresh,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                Accept: "application/json, text/plain, */*",
                'Cache-Control': "no-cache",
                Pragma: "no-cache",
                'X-Requested-By': "92tvt8iy2b"
            },
        },
        refreshVehicleDetails: {
            method: 'GET',
            url: endpointUrls.rego.refresh,
            headers: getMulesoftApiHeadersForVgi(mulesoftApiHeaders),
        },
        refreshCaravanDetails: {
            method: 'GET',
            url: endpointUrls.rego.refresh,
            headers: getMulesoftApiHeadersForVgi(mulesoftApiHeaders),
        },
        isBSBValid: {
            method: 'GET',
            url: endpointUrls.quote.bsbValidation,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'X-Requested-By': '92tvt8iy2b'
            },
        },
        doesUserExist: {
            method: 'HEAD',
            url: endpointUrls.quote.doesUserExist,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc',
                'X-Requested-By': '92tvt8iy2b'
            },
        },
        getPayment: {
            method: 'GET',
            url: endpointUrls.payments.referenceNumber,
            headers: {
                'EY-Access-Key': 'test123',
                'EY-Product-Type': 'pc'
            }
        }
    };

    return {
        regoSearch: function (data) {
            var req = conf.regoSearch;
            req.params = data;
            req.headers.UserID = checkUserID();
            return $http(req);
        },
        addressSearch: function (data) {
            var req = conf.addressSearch;
            req.params = data;
            return $http(req);
        },
        makeSearch: function (data) {
            var req = conf.makeSearch;
            req.params = data;
            return $http(req);
        },
        modelSearch: function (data) {
            var req = conf.modelSearch;
            req.params = data;
            return $http(req);
        },
        carSearch: function (data) {
            var req = conf.carSearch;
            req.params = data;
            return $http(req);
        },
        saveQuote: function (quoteRequest, credentials, params) {
            var req = quoteRequest.quoteID ? conf.updateQuote : conf.createQuote;
            req = Object.extend({}, req);
            req.data = quoteRequest;

            if (params) {
                req.params = params;
            }

            if (quoteRequest.quoteID) {
                req.url = req.url + '/' + quoteRequest.quoteID;
            }
            if (credentials) {
                req.headers['EY-USER-TOKEN'] = credentials.eyUserToken;
            }
            return $http(req);
        },
        getQuickQuote: function (quoteRequests, params, credentials) {
            var req = conf.quickQuote;
            req.data = quoteRequests;
            req.params = params;
            return $http(req);
        },
		triggerGoal: function (quoteRequests) {
			var req = conf.triggerGoal;         
			req.data = quoteRequests;
			return $http(req);
		},
        retrieveSavedQuote: function (quoteId, email) {
            var req = conf.retrieveSavedQuote;
            req = Object.extend({}, req);
            req.url += quoteId;
            req.params = {
                email: email
            };
            return $http(req);
        },
        isCampaignCodeValid: function (code) {
            var req = conf.isCampaignCodeValid;
            req.params = {
                code: code,
                timestamp: (new Date()).getTime()
            };
            return $http(req);
        },
        refreshAddress: function (address) {
            var req = conf.refreshAddress;
            req.data = address;
            return $http(req);
        },
        refreshVehicleDetails: function (vgiId, effectiveDate) {
            var req = conf.refreshVehicleDetails;
            req.params = {
                effectiveDate: effectiveDate,
                id: vgiId,                
                categoryId: 'VehID'
            }
            return $http(req);
        },
        refreshCaravanDetails: function (vgiId, effectiveDate) {
            var req = conf.refreshCaravanDetails;

            req.params = {
                effectiveDate: effectiveDate,
                id: vgiId,
                categoryId: 'VehID'
            }
            return $http(req);
        },
        isBSBValid: function (bsb) {
            var req = conf.isBSBValid, bsbReformatted = null;
            req = Object.extend({}, req);
            // reformat bsb to xxx-xxx format for service
            try {
                bsbReformatted = bsb.replace(/[^0-9.]/g, "").match(/.{3}/g).join('-');
                req.url = req.url + '/' + bsbReformatted;
                return $http(req);
            } catch (ex) {
                throw 'Invalid BSB provided';
            }
        },
        doesUserExist: function (email) {
            var req = conf.doesUserExist;
            req = Object.extend({}, req);
            req.url = req.url + '/' + email;
            return $http(req);
        },
        getPaymentInfo: function (refNumber){
            var req = conf.getPayment;
            req = Object.extend({}, req);
            req.url = req.url + '/' + refNumber;
            return $http(req);
        },
        checkEmbargo: function(postcode, type) {
            var req = conf.embargo;
            req.headers['X-TrackingID'] = uuidv4();
            req.headers['X-SourceSystem'] = 'QBE-SPA-' + type + '-QuoteBuy';  //type: 'Bike' 'Caravan'
            req.headers['X-TargetEnv'] = endpointUrls.quote.embargoTargetEnv;
            req.url = endpointUrls.quote.embargo + "?postalCode=[postcode]&policyLine=" + endpointUrls.quote.embargoPolicyLine + "&asOfDate=[date]";
            req.url = req.url.replace("[date]", moment().tz("Australia/Sydney").format("YYYY-MM-DD"));
            req.url = req.url.replace("[postcode]", postcode);
            return $http(req);
        }
    };

    function checkUserID() {
        if (storage.getItem('uKey').uKey) {
            return storage.getItem('uKey').uKey;
        } else {
            var newKey = util.generateRandomString(5);
            storage.setItem('uKey', { uKey : newKey });
            return newKey;
        }
    }

    function uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    function getMulesoftApiHeadersForVgi(mulesoftApiHeadersConfig) {
        if (endpointUrls.quote && endpointUrls.quote.embargoTargetEnv) {
            mulesoftApiHeadersConfig['X-TargetEnv'] = endpointUrls.quote.embargoTargetEnv;
        }    
        mulesoftApiHeadersConfig['X-TrackingID'] = uuidv4();
        return mulesoftApiHeadersConfig;
    }

    return new GuideWireService(new gwService());
}
